import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getDictionaryWordMap } from '../../../../api/dictionary/queries/getDictionaryWordMap';
import { IDictionaryWordMap } from '../../../../interfaces/Dictionary.interfaces';

export const useGetDictionaryWordMapQuery = () => {
  return useQuery<IDictionaryWordMap, AxiosError>(['dictionary_word_map'], getDictionaryWordMap);
};
